import React, { useState } from "react";
import AppWrapper from "../AppWrapper";
import { Page, BlockStack, Badge } from "@shopify/polaris";
import InsuranceBar from "./Widgets/InsuranceBar";
import ServicesBar from "./Widgets/ServicesBar";
import FleetOverview from "./Widgets/FleetOverview";
import BranchSwitcherModal from "./BranchSwitcherModal";
import { useBranch } from "../../context/BranchContext";

function Dashboard() {
  const { branch, isLargoPlazo } = useBranch();
  const [switcherOpen, setSwitcherOpen] = useState(false);

  return (
    <AppWrapper>
      <Page
        title="GoMove"
        subtitle={branch?.name || ""}
        titleMetadata={isLargoPlazo ? <Badge tone="info">Largo Plazo</Badge> : <Badge>Corto Plazo</Badge>}
        primaryAction={{
          content: "Cambiar Sucursal",
          onAction: () => setSwitcherOpen(true),
        }}
      >
        <BlockStack gap={300}>
          <FleetOverview />
          <InsuranceBar />
          <ServicesBar />
        </BlockStack>
        <BranchSwitcherModal open={switcherOpen} onClose={() => setSwitcherOpen(false)} />
      </Page>
    </AppWrapper>
  );
}

export default Dashboard;
